export default function ConfirmIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" fill="#FFF2C4" />
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM13.3961 9.88184L11.8931 16.9395C11.7877 17.4492 11.9371 17.7393 12.3502 17.7393C12.6402 17.7393 13.0796 17.6338 13.3785 17.3701L13.2466 17.9941C12.816 18.5127 11.8668 18.8906 11.0494 18.8906C9.99469 18.8906 9.54645 18.2578 9.83648 16.9131L10.9439 11.71C11.0406 11.2705 10.9527 11.1123 10.5132 11.0068L9.83648 10.8838L9.95953 10.3125L13.3961 9.88184ZM12 8.25C11.1716 8.25 10.5 7.57843 10.5 6.75C10.5 5.92157 11.1716 5.25 12 5.25C12.8284 5.25 13.5 5.92157 13.5 6.75C13.5 7.57843 12.8284 8.25 12 8.25Z"
        fill="currentColor"
      />
    </svg>
  );
}
